/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
  } from "@/components/ui/select"
import Alert from '../common/Alert'
import { Button } from '@/components/ui/button'
import { makeRequest } from '@/utils/axiosInterceptor'
import { useQueryClient } from "@tanstack/react-query";
import { toast } from 'sonner'
import { isValidDateRange } from '@/utils/formatDateForInput'

const defaultUserData = {
    name: '',
    type: '',
    address: '',
    email: '',
    contact: '',
    allocated_storage: 50,
    allowed_users: 2,
    subscription_active: false,
    subscription_start: '',
    subscription_end: '',
}

export default function HospitalCreateForm({setAddHospitalSheet}) {
    const queryClient = useQueryClient();

    const [userData, setUserData] = React.useState(defaultUserData)



    const createHospital = async () => {
        try {
            console.log('creating')
            if (!isValidDateRange(userData.subscription_start, userData.subscription_end)) {
                toast.error('Start must be before end')
                return
            }

            const payload = {
                ...userData,
                subscription_start: userData.subscription_start
                    ? new Date(userData.subscription_start).toISOString()
                    : null,
                subscription_end: userData.subscription_end
                    ? new Date(userData.subscription_end).toISOString()
                    : null,
            }

            const res = await makeRequest('POST', '/hospitals/create', payload) 
            console.log(res)
            if (res?.status === 201) {
                setActivateAlert(false)
                queryClient.invalidateQueries({
                    queryKey: ["hospital"],
                });
                setUserData(defaultUserData)
                setAddHospitalSheet(false)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const [activateAlert, setActivateAlert] = React.useState(false)
  return (
    <div>
         <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="name" className="text-right">
              Name
            </Label>
            <Input 
                placeholder='Hospital/Clinic Name'
                value={userData.name} onChange={(e) => setUserData({...userData, name: e.target.value})} 
                id="name" 
                className="col-span-3" 
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label  className="text-right">
              Type
            </Label>
            <Select 
                
                onValueChange={(value) => setUserData({...userData, type: value})} 
            >
                <SelectTrigger className="col-span-3">
                    <SelectValue placeholder="Entity Type" />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                    <SelectLabel>Institution Type</SelectLabel>
                    <SelectItem value="Hospital">Hospital</SelectItem>
                    <SelectItem value="Clinic">Clinic</SelectItem>
                    </SelectGroup>
                </SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="address" className="text-right">
              Address
            </Label>
            <Input 
                id="address" 
                value={userData.address} 
                onChange={(e) => setUserData({...userData, address: e.target.value})}  
                className="col-span-3" 
                placeholder='Kanpur, Uttar Pradesh'
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="email" className="text-right">
              Email
            </Label>
            <Input 
                id="email" 
                value={userData.email}
                className="col-span-3" 
                onChange={(e) => setUserData({...userData, email: e.target.value})}
                placeholder='hospital@abc.com'
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="contact" className="text-right">
              Contact
            </Label>
            <Input 
                id="contact" 
                className="col-span-3" 
                onChange={(e) => setUserData({...userData, contact: e.target.value})}
                value={userData.contact}
                placeholder='1234567890'
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Allocated Storage (GB)
            </Label>
            <Input 
                value={userData.allocated_storage} 
                onChange={(e) => setUserData({...userData, allocated_storage: parseInt(e.target.value)})}
                type='number' 
                className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Allowed Users
            </Label>
            <Input 
                value={userData.allowed_users} 
                onChange={(e) => setUserData({...userData, allowed_users: parseInt(e.target.value)})}
                type='number' 
                className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Subscription Active
            </Label>
            <Select 
                
                onValueChange={(value) => setUserData({...userData, subscription_active : value === "active" ? true : false})} 
            >
                <SelectTrigger className="col-span-3">
                    <SelectValue placeholder="Subscription" />
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                    <SelectLabel>Activation</SelectLabel>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="inactive">Inactive</SelectItem>
                    </SelectGroup>
                </SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Subscription Start Date
            </Label>
            <Input 
                onChange={(e) => setUserData({...userData, subscription_start: e.target.value})}
                value={userData.subscription_start}
                type='datetime-local' className="col-span-3"/>
          </div>

          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="username" className="text-right">
              Subscription End Date
            </Label>
            <Input 
                value={userData.subscription_end}
                onChange={(e) => setUserData({...userData, subscription_end: e.target.value})}
                type='datetime-local' 
                className="col-span-3" 
            />
          </div>

          <div className='flex justify-center'>
            <Button onClick={() => setActivateAlert(true)}>Save</Button>
          </div>
        </div>

        <Alert
            open={activateAlert}
            setOpen={setActivateAlert}
            title="Create Hospital/Clinic"
            description ="Are you sure you want to create this new entity ?"
            action={createHospital}
        />
    </div>
  )
}
